(function() {
    'use strict';

    angular.module('swif.patrimoine')
        .controller('ContractTaskSurveyController', ContractTaskSurveyController);


    function ContractTaskSurveyController($scope, swif) {
        'ngInject';
        console.log('init ContractTaskSurveyController');

        $scope.pagination = {page: 1};

        $scope.getTodoSurveys = function(work) {
            return _.where(work._surveys, {
                done: false
            });
        };

        $scope.isWorkValid = function(work) {
            return work.forced ||
                (work.user_id || work.partner_id || work.team_id) &&
                work.date &&
                work.hours;
        };

        $scope.ras = function (surveys) {
            surveys.map(done).map(ras);
        };

        $scope.filterOncategories = function (survey, index, array) {
            //get categories activated, then get the corresponding properties
            //then filter if the value.site_property_id is in this list
            return survey._filteredOnCategory !== false;
        };

        $scope.toggleFilterOnCategory = toggleFilterOnCategory;

        $scope.$watch('model._controls', loadCategories);


        function done(survey) {
            survey.done = true;
            return survey;
        }

        function ras(survey) {
            if (!survey.notes) {
                survey.notes = 'RAS';
            }
            return survey;
        }

        function loadCategories() {
            /**
             * Survey ->  Property -> Category
             * get all the property with ID/ category
             * group category & keep the link with property
             * so we can filter the list on property ids
             */
            var controls = $scope.model._controls;
            if (!$scope.model._controls) {
                return;
            }
            //contain all surveys
            var surveys = [];
            controls.map((control) => {
                // inserts each elements of control._surveys to the beginning of surveys
                surveys.unshift(...control._surveys);
            });
            //contain all properties
            var properties = surveys.map((survey) => {
                return survey.site_property_id[0];
            });
            var filter = {
                fields: ['id', 'name', 'category_id']
            };
            swif.data.addFilter(filter, 'id', 'in', properties);
            swif.data.searchRead('patrimoine_property', filter).then(function (data) {
                surveys.map((survey) => {
                    data.records.forEach(function (property) {
                        if (property.id === survey.site_property_id[0]) {
                            survey._category_id = property.category_id[0];
                            survey._category_name = property.category_id[1];
                        }
                    });
                });
                controls.map((control) => {
                    //contain global count of categories + info
                    control._ppcategories = {};
                    control._surveys.map((survey) => {
                        if (!control._ppcategories[survey._category_id]) {
                            control._ppcategories[survey._category_id] = {
                                count: 0,
                                id: survey._category_id,
                                name: survey._category_name,
                                surveys: [],
                                activated: false
                            };
                        }
                        control._ppcategories[survey._category_id].count += 1;
                        control._ppcategories[survey._category_id].surveys.push(survey);
                    });
                });
            });
        }

        function toggleFilterOnCategory(category, control) {
            category.activated = !category.activated;
            var hasOneCategoryActivated = false;
            for (let cat in control._ppcategories) {
                if (cat.activated) {
                    hasOneCategoryActivated = true;
                    break;
                }
            }
            control._surveys.map((survey) => {
                if (survey._category_id === category.id) {
                    if (category.activated) {
                        delete survey._filteredOnCategory;
                    } else {
                        survey._filteredOnCategory = false;
                    }
                } else if (category.activated) {
                    if (!control._ppcategories[survey._category_id].activated) {
                        survey._filteredOnCategory = false;
                    }
                } else if (!category.activated) {
                    if (!control._ppcategories[survey._category_id].activated) {
                        if (hasOneCategoryActivated) {
                            survey._filteredOnCategory = false;
                        } else {
                            delete survey._filteredOnCategory;
                        }
                    }
                }
            });
        }
    }

})();
